import React from 'react';
import { 
  Wrench, Heart, Utensils, Sparkles, 
  Stethoscope, FileText, Award
} from 'lucide-react';

const ServicesSection = ({ className = "" }) => {
  const services = [
    {
      icon: Wrench,
      title: 'Professional Maintenance',
      description: 'Full-fledged professionally managed maintenance services for hassle-free living',
      features: ['24/7 Support', 'Expert Team', 'Quick Response']
    },
    {
      icon: Heart,
      title: '24/7 Nursing Staff',
      description: 'Round-the-clock nursing care available whenever you need it',
      features: ['Trained Nurses', 'Emergency Care', 'Health Monitoring']
    },
    {
      icon: Utensils,
      title: 'Nutritious Meals',
      description: 'Veg and Non-veg meals prepared with care and nutrition in mind',
      features: ['Fresh Ingredients', 'Custom Menus', 'Dietary Needs']
    },
    {
      icon: Sparkles,
      title: 'Housekeeping & Laundry',
      description: 'Professional housekeeping and laundry services at your convenience',
      features: ['Daily Cleaning', 'Laundry Service', 'Room Maintenance']
    },
    {
      icon: Stethoscope,
      title: 'Doctor Consultation',
      description: 'Periodic doctor consultations to monitor and maintain your health',
      features: ['Regular Check-ups', 'Specialists', 'Health Plans']
    },
    {
      icon: FileText,
      title: 'Medical Records',
      description: 'Comprehensive medical record management for your peace of mind',
      features: ['Digital Records', 'Easy Access', 'Secure Storage']
    }
  ];

  return (
    <div className={`pt-20 sm:pt-28 pb-10 sm:pb-20 bg-white ${className}`}>
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          {/* <div className="inline-flex items-center gap-2 bg-red-50 px-6 py-3 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-8">
            <Award className="w-4 h-4" />
            Comprehensive Services
          </div> */}
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight">
            Comprehensive Care & 
            <span className="block text-[var(--primarycolor)] font-normal">Support Services</span>
          </h2>
          
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Everything you need for a comfortable, worry-free lifestyle at Dignity
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                className="bg-gradient-to-br from-white to-red-50/30 rounded-3xl border border-gray-100 p-4 sm:p-8 group hover:border-[var(--primarycolor)]/30 hover:shadow-2xl hover:shadow-red-500/5 transition-all duration-500 hover:-translate-y-1"
              >
                {/* Icon */}
                <div className="w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-br from-red-50 to-red-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 group-hover:shadow-lg group-hover:shadow-red-500/20">
                  <IconComponent className="w-5 sm:w-8 h-5 sm:h-8 text-[var(--primarycolor)]" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-[var(--primarycolor)] transition-colors duration-300">
                  {service.title}
                </h3>

                {/* Decorative Line */}
                <div className="w-12 h-1 bg-gradient-to-r from-[var(--primarycolor)] to-red-300 rounded-full mb-4 group-hover:w-20 transition-all duration-500"></div>

                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {service.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1.5 bg-white text-gray-700 text-xs rounded-lg border border-gray-200 group-hover:border-[var(--primarycolor)]/20 group-hover:bg-red-50/50 transition-all duration-300"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;